export default "__VITE_ASSET__ChUCxFOo__"